<template>
    <div class="wrapper-body flex-1">
        <ListCorrespondences :nodeId="nodeId" />
    </div>
</template>

<script>
    import ListCorrespondences from '@/components/ListCorrespondences.vue';

	export default {
		name: 'InboxView',
        components: { ListCorrespondences },
        data () 
        {
            return {
                nodeId: 0
                //purposeFilter: this.$route.query.purposeFilter
            }
        },
        mounted () 
        {
            this.nodeId = 2;
            //this.purposeFilter = '';
        },
	}
</script>